import { RootState } from "@/store/rootReducer";
import { AppDispatch } from "@/store/store";
import { openInspectionById } from "@/store/thunk/Inspection.thunk";
import { Inspection } from "@/types/Inspection.type";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useStoredInspection } from "@/hooks/useStoredInspection";
import { InspectionOwner } from "@/enums/InspectionOwner.enum";

export const useOpenInspection = (inspectionId?: string) => {
    const dispatch = useDispatch<AppDispatch>();

    const storedInspection = useStoredInspection(inspectionId);
    const inspection = useSelector((state: RootState) => state.openedInspection.inspection) || {} as Inspection;
    const isModified = useSelector((state: RootState) => state.openedInspection.isModified);
    const canOpenInspection = !storedInspection?.locked || storedInspection?.locked?.by === InspectionOwner.UI;


    useEffect(() => {

        if (inspectionId && canOpenInspection) {
            dispatch(openInspectionById(inspectionId));
        }
    }, [inspectionId, dispatch, canOpenInspection]);
    return { inspection, isModified, canOpenInspection };
};


